import { Translate } from '@dreryk/react-common';

import { gynecologicalInterviewTranslationKeys } from '../../../translations';

export const GynecologicalInterviewRegularInterviewEntryCell = (): JSX.Element => {
   return <Translate>{gynecologicalInterviewTranslationKeys.interviewType.REGULAR_INTERVIEW}</Translate>;
};
